import moment from 'moment';
import { defaultDateTimeFormat } from '../../../../../constants';
import { CustomRouteItem } from '../index';

export const getRouteGanttEndMoment = (startTime: string | undefined | null, endTime: string | undefined | null) => {
  if (endTime) {
    return moment(endTime, defaultDateTimeFormat);
  }
  if (startTime) {
    return moment(startTime, defaultDateTimeFormat).clone().add('0', 'minute');
  }
  return undefined;
};

export const getRouteGanttDefaultStart = (routeLineSegments: CustomRouteItem[], selectedDate?: string) => {
  const startUnixTime = moment(routeLineSegments.reduce((start, route) => (moment(route.start_time).isBefore(start)
    ? route.start_time : start), routeLineSegments?.[0]?.start_time)).clone().subtract('30', 'minutes').valueOf();
  if (selectedDate) {
    const selectedUnixTime = moment(selectedDate).valueOf();
    return selectedUnixTime > startUnixTime ? selectedUnixTime : startUnixTime;
  }

  return startUnixTime;
};

export const getRouteGanttDefaultEnd = (routeLineSegments: CustomRouteItem[]) => (
  moment(routeLineSegments.reduce((end, route) => (moment(route.end_time).isAfter(end)
    ? route.end_time : end), routeLineSegments?.[0]?.end_time)).clone().add('30', 'minutes').valueOf()
);
